import { render, staticRenderFns } from "./nianlun.vue?vue&type=template&id=0e06d43a&scoped=true&"
import script from "./nianlun.vue?vue&type=script&lang=js&"
export * from "./nianlun.vue?vue&type=script&lang=js&"
import style0 from "./nianlun.vue?vue&type=style&index=0&id=0e06d43a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06d43a",
  null
  
)

export default component.exports